'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Animate = require('react-move/Animate');

var _Animate2 = _interopRequireDefault(_Animate);

var _d3Ease = require('d3-ease');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var show = _ref.show,
      children = _ref.children;
  return _react2.default.createElement(
    _Animate2.default,
    {
      show: show,
      start: {
        opacity: 0,
        opacityModal: 0,
        y: -100
      },
      enter: [{
        opacity: [1],
        timing: { duration: 300, ease: _d3Ease.easeCircleOut }
      }, {
        y: [0],
        opacityModal: [1],
        timing: { delay: 500, duration: 500, ease: _d3Ease.easeBackOut }
      }],
      leave: [{
        y: [-100],
        opacityModal: [0],
        timing: { duration: 500, ease: _d3Ease.easeBackOut }
      }, {
        opacity: [0],
        timing: { delay: 300, duration: 300, ease: _d3Ease.easeCircleOut }
      }]
    },
    children
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-modal-es/lib/Animation.js
// module id = 331
// module chunks = 0